module.exports = __webpack_public_path__ + "static/media/expired.7fcafd2f.png";